import { connect } from 'react-redux';
import { emit as _emit } from '../../actions/events';
import { open as _open, authenticate, authenticateError, authenticateEmailTaken, authenticateEmailRequired } from '../../actions/social';
import { Social } from '../../components/Social';

function mapStateToProps(state) {
  return {
    social: state.social
  };
}

function mapDispatchToProps(dispatch) {
  return {
    open: function open(parameters) {
      return dispatch(_open(parameters));
    },
    socialAuthenticate: function socialAuthenticate(parameters) {
      return dispatch(authenticate(parameters));
    },
    socialAuthenticateEmailRequired: function socialAuthenticateEmailRequired(parameters) {
      return dispatch(authenticateEmailRequired(parameters));
    },
    socialAuthenticateEmailTaken: function socialAuthenticateEmailTaken(parameters) {
      return dispatch(authenticateEmailTaken(parameters));
    },
    socialAuthenticateError: function socialAuthenticateError(type) {
      return dispatch(authenticateError(type));
    },
    emit: function emit(type, event) {
      return dispatch(_emit(type, event));
    }
  };
}

export var SocialContainer = connect(mapStateToProps, mapDispatchToProps)(Social);